export { default } from './RegisterBasicInfo';
